// @flow
import type {Element} from 'react'
import React from 'react'
import classNames from 'classnames'

import ChangeTitle from 'components/proposals/Part/ui/Summary/ChangeTitle'
import DiffComponent from 'components/proposals/Part/ui/DiffComponent'
import Value from '../../Value'

type Props = {|
  changeKey: string,
  className: string,
  title: string,
  value: Value,
|}

function Scalar({changeKey, className, title, value}: Props): null | Element<"div"> {
  const cssClassNames = classNames('proposal-summary-scalar', `test-field-${changeKey}`, className)

  if (!value.isChanged)
    return null

  return (
    <div className={cssClassNames} key={changeKey}>
      <ChangeTitle
        title={title}
      />
      <DiffComponent htmlDiff={value.htmlDiff} />
    </div>
  )
}

Scalar.defaultProps = {
  className: '',
}

export default Scalar
